/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Tooltip } from 'bold-ui'
import { isAfter, isBefore, startOfDay } from 'date-fns'
import { dateAsDdMmYyyy } from 'util/date/formatDate'

interface DayDelimiterTooltipProps {
  day: Date
  minDate: Date
  maxDate: Date
  minDateMessage?: string
  maxDateMessage?: string
}

const createTooltipText = (props: DayDelimiterTooltipProps) => {
  const { day, minDate, maxDate, minDateMessage, maxDateMessage } = props

  if (isBefore(startOfDay(day), startOfDay(minDate))) {
    return minDateMessage ?? `Data do atendimento deve ser posterior ou igual à ${dateAsDdMmYyyy(minDate)}`
  }

  if (isAfter(day, maxDate)) {
    return maxDateMessage ?? `Data do atendimento deve ser anterior ou igual à ${dateAsDdMmYyyy(maxDate)}`
  }

  return undefined
}

export function DayDelimiterTooltip(props: DayDelimiterTooltipProps) {
  return (
    <Tooltip text={createTooltipText(props)}>
      <span>{props.day.getDate()}</span>
    </Tooltip>
  )
}
